import { type SVGProps } from 'react';

export const WhatsAppIcon = ({
  width = 20,
  height = 20,
  ...props
}: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1px"
      d="M9.617 2.083c1.853.001 3.596.673 4.956 1.902l.268.254A7.28 7.28 0 0 1 17 9.435c-.002 4.048-3.313 7.346-7.383 7.346h-.004c-1.236 0-2.45-.31-3.528-.895l-.174-.093-.192.05-3.34.87.888-3.23.056-.201-.106-.182a7.3 7.3 0 0 1-.984-3.67c.001-3.922 3.108-7.14 7.004-7.337l.38-.01Zm.002.326c-3.888 0-7.053 3.147-7.055 7.02a6.98 6.98 0 0 0 1.078 3.736v.002l.037.06-.602 2.193-.23.835.838-.218 2.278-.596.061.036h.001c1.016.6 2.17.935 3.352.975l.237.004h.503v-.02c3.653-.257 6.55-3.296 6.552-7.002 0-1.875-.733-3.64-2.064-4.967A7.025 7.025 0 0 0 9.62 2.41h-.001ZM6.826 6.306c.126 0 .244 0 .344.005l.015.031v.001c.082.195.22.532.346.836.103.249.209.502.258.61-.047.095-.055.113-.095.16-.131.152-.197.243-.27.315-.036.036-.17.16-.238.343a.762.762 0 0 0 .073.664c.124.211.551.907 1.196 1.48a5.616 5.616 0 0 0 1.481.954l.212.092a.93.93 0 0 0 .526.11.784.784 0 0 0 .498-.277l.002.001c.093-.106.393-.46.577-.704l.014.007.149.068a74.087 74.087 0 0 1 .93.447l.143.071c.045.023.09.043.125.06v.004c-.01.123-.042.293-.11.48-.023.067-.14.21-.382.365a2.02 2.02 0 0 1-.456.219l-.094.023a2.212 2.212 0 0 1-1.016-.06 10.84 10.84 0 0 1-1.077-.395c-1.827-.785-3.036-2.633-3.163-2.801a4.315 4.315 0 0 1-.392-.628c-.173-.338-.312-.73-.312-1.1 0-.566.214-.903.395-1.118l.163-.179c.07-.076.14-.084.158-.084Z"
    />
  </svg>
);
